import { render, staticRenderFns } from "./GirthItem.vue?vue&type=template&id=447150de&scoped=true&"
import script from "./GirthItem.vue?vue&type=script&lang=js&"
export * from "./GirthItem.vue?vue&type=script&lang=js&"
import style0 from "./GirthItem.vue?vue&type=style&index=0&id=447150de&prod&lang=less&scoped=true&"
import style1 from "./GirthItem.vue?vue&type=style&index=1&id=447150de&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447150de",
  null
  
)

export default component.exports